/**
 * Event propagation workaround for IOS 10+ (May 17 2018)
 *
 * By default, iOS disables event propagation for elements, which don't have direct binded event
 * listeners. For example,
 *
 * <div id='one'>
 *   <div id='two'></div>
 * </div>
 * <script>
 *   const element = document.getElementById('one');
 *   element.addEventListener('click', (e) => alert(e.target));
 * </script>
 *
 * On iOS, alert() will not be showed once user clicks on div#two, if div#two doesn't have other
 * direct event listeners.
 *
 * The expected behavior can be restored for specific elements by adding css cursor: pointer; to
 * their styles.
 */

import bowser from 'yola-bowser';

const reviveIOSEventPropagation = (liveDOM, elementSelector = '[data-ws-ios] *') => {
  if (!bowser.ios) return;

  const style = liveDOM.createElement('style');
  style.className = 'ios-event-propagation-reviver';
  style.innerHTML = `${elementSelector} { cursor: pointer!important; }`;
  liveDOM.head.insertAdjacentElement('beforeend', style);
};

export default reviveIOSEventPropagation;
